export default __webpack_public_path__ + "static/media/economicRecession.png.webp";